import { combineReducers } from 'redux';

import dialogs from './dialogs';

const reducer = combineReducers({
  [dialogs.name]: dialogs.reducer,
});

export default reducer;
